/* Tax-exempt checkout flow.
   Ported 1:1 from the legacy theme (sections/cart.liquid, lines 348-578) and
   wired to the new theme's two checkout buttons:
     #checkout            -> main cart page (form="cart")
     #CartDrawer-Checkout -> mini cart drawer (form="CartDrawer-Form")

   Behaviour is identical to the old site:
     - already-uploaded tax-exempt customer  -> straight to /checkout
     - tax-exempt customer, no file selected  -> show "Please select document!"
     - tax-exempt customer, file selected     -> upload to endpoint, then /checkout
     - everyone else                           -> open the customer-type pop-up
   The pop-up: "Sales Tax Exempt Customer" -> sales-tax-form page;
   "All Other Customers" -> /checkout. */
(function () {
  const modal = document.getElementById('TaxExemptModal');
  if (!modal) return;

  const CUSTOMER_TAX_EXEMPT = modal.dataset.customerTaxExempt === 'true';
  const CUSTOMER_EMAIL = modal.dataset.customerEmail || '';
  const SALES_TAX_FORM_URL = modal.dataset.salesTaxFormUrl;
  const UPLOAD_URL = modal.dataset.uploadUrl;

  const CHECKOUT_SELECTOR = '#checkout, #CartDrawer-Checkout';

  /* ---- cookie helpers (ported from the old custom-script.js) ----------- */
  function setCustomCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    document.cookie = cname + '=' + cvalue + ';expires=' + d.toUTCString() + ';path=/';
  }

  function getCustomCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  }

  /* ---- has this tax-exempt customer already uploaded their document? --- */
  let isTaxExemptFileAlreadyUploaded = false;

  function hideUploadFields() {
    document.querySelectorAll('.js-tax-exempt-form').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  if (CUSTOMER_TAX_EXEMPT) {
    const uploadedData = getCustomCookie('ozo-customer-tax-exempt-file-uploaded');
    if (uploadedData) {
      try {
        const uploaded = JSON.parse(uploadedData);
        if (uploaded.includes(CUSTOMER_EMAIL)) {
          isTaxExemptFileAlreadyUploaded = true;
          hideUploadFields();
        }
      } catch (e) {
        /* ignore malformed cookie */
      }
    }
  }

  /* ---- inline file-field validation ------------------------------------ */
  function errorFor(fileInput) {
    const wrap = fileInput.closest('.js-tax-exempt-form');
    return wrap ? wrap.querySelector('.js-tax-document-error') : null;
  }

  function validateDocument(fileInput) {
    const err = errorFor(fileInput);
    if (!err) return fileInput.files.length > 0;
    if (fileInput.files.length === 0) {
      err.classList.add('is-visible');
      return false;
    }
    err.classList.remove('is-visible');
    return true;
  }

  document.addEventListener('change', function (e) {
    const fileInput = e.target.closest('.js-tax-document');
    if (fileInput) validateDocument(fileInput);
  });

  /* ---- upload the document, then run the callback ---------------------- */
  async function sendData(form, onCompletedUpload) {
    const formData = new FormData(form);
    try {
      await fetch(UPLOAD_URL, { method: 'POST', body: formData });

      const uploadedData = getCustomCookie('ozo-customer-tax-exempt-file-uploaded');
      let uploaded = [];
      if (uploadedData) {
        try {
          uploaded = JSON.parse(uploadedData);
        } catch (e) {
          uploaded = [];
        }
      }
      uploaded.push(CUSTOMER_EMAIL);
      setCustomCookie('ozo-customer-tax-exempt-file-uploaded', JSON.stringify(uploaded), 90);

      onCompletedUpload();
    } catch (e) {
      console.error(e);
    }
  }

  /* ---- pop-up open / close --------------------------------------------- */
  function openModal() {
    modal.classList.add('is-open');
    document.body.classList.add('tax-exempt-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('tax-exempt-modal-open');
  }

  /* ---- checkout button interception (both cart + drawer) --------------- */
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(CHECKOUT_SELECTOR);
      if (!btn || btn.disabled) return;

      e.preventDefault();

      if (isTaxExemptFileAlreadyUploaded) {
        window.location.href = '/checkout';
        return;
      }

      if (CUSTOMER_TAX_EXEMPT) {
        const form = document.getElementById(btn.getAttribute('form'));
        const fileInput = form && form.elements ? form.elements.namedItem('document') : null;

        if (!fileInput || fileInput.files.length === 0) {
          if (fileInput) validateDocument(fileInput);
          return;
        }
        if (errorFor(fileInput)) errorFor(fileInput).classList.remove('is-visible');

        sendData(form, function () {
          window.location.href = '/checkout';
        });
      } else {
        openModal();
        window.sessionStorage.setItem('ozo-redirect-to', '/cart');
      }
    },
    true
  );

  /* ---- pop-up choices --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    // "Sales Tax Exempt Customer"
    if (e.target.closest('[data-tax-exempt-yes]')) {
      closeModal();
      window.sessionStorage.setItem('ozo-customer-save-tax-exempt', '1');
      setCustomCookie('ozo-customer-tax-exempt', '1', 1);
      window.sessionStorage.setItem('ozo-redirect-to', '/cart');
      window.location.href = SALES_TAX_FORM_URL;
      return;
    }

    // "All Other Customers"
    if (e.target.closest('[data-tax-exempt-no]')) {
      closeModal();
      window.location.href = '/checkout';
      return;
    }

    // dismiss (X button) — back out without choosing
    if (e.target.closest('[data-tax-exempt-close]')) {
      closeModal();
    }
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();
